<template>
    <div>
        <div v-if="tableData.length > 0">
            <el-table
                    :data="tableData"
                    style="width: 100%">
                <el-table-column
                        label="申请时间"
                        width="210">
                    <template slot-scope="scope">
                        <i class="el-icon-time"></i>
                        <span style="margin-left: 10px">{{ scope.row.creationTime |formattime}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                        label="发票抬头"
                        width="250">
                    <template slot-scope="scope">{{ scope.row.enterpriseInvoiceId.fptaitou }}</template>
                </el-table-column>
                <el-table-column
                        label="发票总额"
                        width="100">
                    <template slot-scope="scope">{{ scope.row.fprental |formats }}</template>
                </el-table-column>
                <el-table-column
                        prop="invoicesty"
                        label="发票状态"
                        width="80">
                </el-table-column>
                <el-table-column
                        prop="mailsty"
                        label="邮寄状态"
                        width="80">
                </el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <!--<el-button-->
                        <!--size="mini"-->
                        <!--@click="handleEdit(scope.$index, scope.row)">详情-->
                        <!--</el-button>-->
                    </template>
                </el-table-column>
            </el-table>
            <el-col style="text-align: right">
                <el-pagination
                        background
                        layout="total, prev, pager, next"
                        :total="total">
                </el-pagination>
            </el-col>
        </div>
        <div v-if="tableData.length == 0">
            <el-alert
                    :closable="false"
                    title="提示信息"
                    type="warning"
                    description="没有发票信息！"
                    show-icon>
            </el-alert>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';
    import moment from "moment"
    export default {
        name: "check-the-invoice",
        components: {
            axios
        },
        data() {
            return {
                tableData: [],
                total: 0,
                page: 1,
                limit: 10,
            }
        },
        methods: {
            //获取开票数据
            getAllOpeninvoicelist() {
                axios.post("/Api/admin/getOpeninvoicelist", {page: this.page, limit: this.limit}).then(res => {
                    if (res.statusText == "OK") {
                        if (res.data.errcode == 0) {
                            this.total = res.data.total;
                            this.tableData = res.data.data;
                        } else if (res.data.errcode == 4000) {
                            //请先登入
                            this.$message({
                                showClose: true,
                                message: '请先登入！',
                                type: 'error',
                                duration: 10000
                            });
                            this.$router.push({
                                name: 'Cart',
                            });
                        } else {
                            this.$message({
                                showClose: true,
                                message: res.data.message,
                                type: 'error',
                                duration: 10000
                            });
                        }
                    }
                });
            },
        },
        mounted() {
            this.getAllOpeninvoicelist();
        },
        filters: {  //数据过滤器
            formats: function (value) {
                var _val;
                value = Number(value).toFixed(2);
                if (value == 0) {
                    value = 0;
                    return value + ".00";
                }
                _val = value.split('.');
                return '￥ ' + _val[0] + '.' + _val[1];
            },
            formattime: function (value) {
                return moment(new Date(value)).format('YYYY-MM-DD HH:mm:ss');
            }
        }
    }
</script>

<style>

</style>